// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordRecoveryFinished_container__1r6-7","icon":"PasswordRecoveryFinished_icon__Dmd30","button":"PasswordRecoveryFinished_button__Blm5H"};